import { type FC } from 'react';

import { ChallengeStateName } from '__generated__/GQL';

import WaitingForValidationChallenge from '../components/WaitingForValidationChallenge';
import { useVerifyChallenge } from '../hooks/useVerifyChallenge';
import { useVerifyMdaSCAOperation } from '../hooks/useVerifyMdaSCAOperation';
import { type StrongAuthenticationChallengeChildModalProps } from '../utils/types';

const AsyncChallenge: FC<StrongAuthenticationChallengeChildModalProps> = ({
  challengeId,
  challengeMethod,
  executeStrongAuthenticationOperation,
  isOpen,
  onClose,
  payload,
}) => {
  const { decline } = useVerifyChallenge();

  // Hook that executed only if challengeId is set
  const { isRequesting, isVerifying, verifyMdaOperation } =
    useVerifyMdaSCAOperation({
      challengeId,
      challengeMethod,
      executeStrongAuthenticationOperation,
      payload,
    });

  const declineOnClose = (value: boolean) => {
    decline({
      challengeId,
      name: ChallengeStateName.ChallengeDeclined,
    }).finally(() => {
      onClose(value);
    });
  };

  return (
    <WaitingForValidationChallenge
      challengeId={challengeId}
      isOpen={isOpen}
      isRequesting={isRequesting}
      isVerifying={isVerifying}
      method={challengeMethod}
      onClose={declineOnClose}
      verifyMdaOperation={verifyMdaOperation}
    />
  );
};

export default AsyncChallenge;
